import { commonColors } from './common.colors';
import { ModalColors } from './ui.colors';
import { palette, createColor } from './palette.colors';

/**
 * Repair Details page color definitions
 */
export const repairDetailsColors = {
  mainBackground: createColor(palette.gray.lightWhite, palette.dark.background),
  repairShiftSectionBGColor: createColor(palette.opacity.blue13, palette.opacity.blue13),
  repairShiftMainSectionBGColor: createColor(palette.gray.white, palette.dark.content),
  repairShiftTitle: createColor(palette.opacity.blue08, palette.opacity.blue08),
  repairShiftTitleText: createColor(palette.blue.onTint, palette.gray.white),
  repairSiftSubTitle: createColor(palette.opacity.black0D, palette.opacity.black0D),
  repairTitle: createColor(palette.blue.onTint, palette.dark.text),
  repairShiftTime: createColor(palette.gray.lightDarkGrey, palette.gray.charcoal),
  repairSubShiftTime: createColor(palette.blue.onTint, palette.gray.white),
  newRepairCTABGColor: createColor(palette.gray.white, 'transparent'),
  newRepairCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  newRepairCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  tabsBGColor: createColor(palette.gray.white, palette.dark.content),
  tabsBorderColor: createColor(palette.gray.neutral, palette.dark.techBorder),
  tabsTextColor: createColor(palette.gray.darkest, palette.gray.white),
  // WCAG 1.4.3: was palette.blue.primary (#2B78CA, 3.98:1 vs #EAF1FA sky-blue tab bg) → palette.blue.secondary (#1A65B8, ≥4.6:1)
  tabsSelectedColor: createColor(palette.blue.secondary, palette.blue.secondary),
  mainTabsSelectedColor: createColor(palette.blue.secondary, palette.blue.secondary),
  mainTabDisabledColor: createColor(palette.gray.white, palette.gray.white),
  tabContainerBG: createColor(palette.gray.white, palette.dark.content),
  tabContainerBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  tabsSelectedTextColor: createColor(palette.gray.white, palette.gray.white),
  partsCountColor: createColor(palette.semantic.orange, palette.semantic.orange),
  tileCardTitle: createColor(palette.blue.onTint, palette.gray.darkest),
  tileCardStatus: createColor(palette.gray.charcoal, palette.gray.charcoal),
  tileCardCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  tileCardConfirmText: createColor(palette.gray.white, palette.gray.white),
  tileCardCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  tileCardCTABG: createColor(palette.opacity.gray80, palette.dark.cardSelected),
  tileCardCTASelectedText: createColor(palette.gray.darkest, palette.gray.darkest),
  tileCardCTASelectedBorder: createColor(palette.borders.selected, palette.borders.blue),
  titleCardCTASelectedBGColor: createColor(palette.blue.sky, palette.dark.cardSelected),
  tileCardNumberBorder: createColor(palette.gray.borderAlt2, palette.gray.borderAlt2),
  tileCardNumberText: createColor(palette.blue.onTint, palette.gray.darker),
  titleCardActionColor: createColor(palette.blue.primary, palette.blue.primary),
  titleCardEditActionColor: createColor(palette.gray.white, palette.dark.content),

  repairDetailsTitle: createColor(palette.blue.onTint, palette.gray.white),
  repairHistoryColor: createColor(palette.blue.primary, palette.blue.primary),
  workOrderStatusTitle: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  workOrderStatusRepairTitle: createColor(palette.gray.field, palette.gray.field),
  workOrderStatusDesc: createColor(palette.blue.onTint, palette.dark.textAlt),
  workOrderStatusCTABGColor: createColor(palette.gray.white, 'transparent'),
  workOrderStatusCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  workOrderStatusEnabledCTABGColor: createColor(palette.special.transparent, palette.special.transparent),
  workOrderStatusEnabledCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  workOrderStatusEnabledCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  repairDetailsId: createColor(palette.gray.field, palette.gray.field),
  assetInfo: createColor(palette.blue.onTint, palette.gray.white),
  assetInfoDetailsKey: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  assetInfoDetailsValue: createColor(palette.blue.onTint, palette.dark.textAlt),
  progressTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  progressSubTitle: createColor(palette.gray.darker, palette.gray.darker),
  progressSubTitleValue: createColor(palette.gray.field, palette.gray.field),
  progressBarCardSubTitle: createColor(palette.gray.charcoal, palette.gray.charcoal),
  progressBarCardTitleValue: createColor(palette.gray.darker, palette.gray.darker),
  activeTime: createColor(palette.blue.onTint, palette.dark.textAlt),
  activeTimeValue: createColor(palette.gray.darkest, palette.gray.darkest),
  repairStatusCardBorder: createColor(palette.opacity.gray50, palette.dark.techBorder),
  separator: createColor(palette.gray.extraLight, palette.dark.techBorder),
  activeTimeBGColor: createColor(palette.gray.veryLight, palette.gray.veryLight),
  activeTimeBorderColor: createColor(palette.gray.divider, palette.gray.divider),
  taskFlowInactive: createColor(palette.gray.extraLight, palette.gray.extraLight),
  taskFlowActive: createColor(palette.blue.primary, palette.blue.primary),
  completedRepairs: createColor(palette.blue.primary, palette.blue.primary),
  inCompletedRepairs: createColor(palette.gray.neutral, palette.gray.neutral),
  completedRepairsText: createColor(palette.gray.white, palette.gray.white),
  inCompletedRepairsText: createColor(palette.gray.white, palette.gray.zinc),
  enabledText: createColor(palette.gray.black, palette.gray.white),
  disabledText: createColor(palette.gray.black, palette.gray.zinc),
  taskNameBG: createColor(palette.backgrounds.white, palette.gray.zinc),

  searchTitle: createColor(palette.gray.field, palette.gray.white),
  ownRequestCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  ownRequestCTAText: createColor(palette.gray.black, palette.dark.textAlt),
  ownRequestCTAIconColor: createColor(palette.gray.black, palette.dark.textAlt),
  searchBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  searchLeftIconColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  searchRightIconColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  searchRightIconBGColor: createColor(palette.gray.lightWhite, palette.gray.lightWhite),
  searchRightIconBorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  searchPlaceHodlerColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  scanIconBorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  scanIconTextColor: createColor(palette.gray.black, palette.gray.black),
  scanIconBGColor: createColor(palette.gray.white, palette.gray.white),
  partsHistoryCTABorder: createColor(palette.gray.neutral, palette.gray.neutral),
  partsHistoryCTAText: createColor(palette.gray.black, palette.gray.black),
  partsHistoryCTABG: createColor(palette.gray.white, 'transparent'),
  partsHistoryCTAIconColor: createColor(palette.gray.darker, palette.dark.textAlt),
  messagesCTABorder: createColor(palette.gray.white, palette.gray.white),
  messagesCTAText: createColor(palette.gray.black, palette.gray.black),
  messagesCTAIconColor: createColor(palette.gray.black, palette.dark.textAlt),
  messagesCountTextColor: createColor(palette.gray.white, palette.gray.white),
  messagesCountBGColor: createColor(palette.blue.primary, palette.blue.primary),
  configuredTitle: createColor(palette.blue.onTint, palette.gray.white),
  configuredSubTitle: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  submitPartsCTABorder: createColor(palette.gray.white, 'transparent'),
  submitPartsCTAText: createColor(palette.gray.white, palette.gray.white),
  submitPartsCTAIconColor: createColor(palette.gray.white, palette.gray.white),
  submitPartsCountTextColor: createColor(palette.gray.white, palette.gray.white),
  submitPartsBGColor: createColor(palette.blue.primary, palette.blue.primary),
  checkboxColor: createColor(palette.gray.neutral, palette.gray.neutral),
  checkboxSelectedColor: createColor(palette.blue.primary, palette.blue.primary),
  checkboxSelectedIconColor: createColor(palette.gray.white, palette.gray.white),
  qtyBorder: createColor(palette.gray.white, palette.gray.white),
  qtyMinusIconColor: createColor(palette.gray.darker, palette.gray.darker),
  qtyPlusIconColor: createColor(palette.gray.darker, palette.gray.darker),
  qtyTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  qtyDotsColor: createColor(palette.gray.darkest, palette.gray.darkest),
  separatorColor: createColor(palette.gray.divider, palette.gray.divider),

  saveCTABGColor: createColor(palette.blue.primary, palette.blue.primary),
  saveCTATitleColor: createColor(palette.gray.white, palette.gray.white),
  saveCTAIconColor: createColor(palette.gray.white, palette.gray.white),
  cancelCTABorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  cancelCTATextColor: createColor(palette.gray.darkest, palette.gray.darkest),

  notesBorder: createColor(palette.gray.neutral, palette.borders.tech),
  notesFilterUnselectBGColor: createColor(palette.opacity.gray80alt, palette.dark.cardSelected),
  notesFilterSelectBGColor: createColor(palette.blue.sky, palette.blue.sky),
  notesFilterSelectBorder: createColor(palette.borders.selected, palette.borders.selected),
  notesFilterText: createColor(palette.gray.darkest, palette.dark.textAlt),
  notesMainTitleColor: createColor(palette.gray.field, palette.gray.white),
  notesTitleColor: createColor(palette.blue.onTint, palette.gray.white),
  notesTypeColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  notesDescColor: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  notesUserColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  notesUserBGColor: createColor(palette.gray.avatar, palette.gray.avatar),
  notesUserDate: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  notesUserDateIcon: createColor(palette.gray.charcoal, palette.dark.textAlt),
  viewFullNoteCTAColor: createColor(palette.blue.primary, palette.blue.primary),
  viewFullNoteIconColor: createColor(palette.blue.primary, palette.blue.primary),
  divider: createColor(palette.gray.extraLight, palette.dark.techBorder),
  notesUserNameColor: createColor(palette.gray.darkest, palette.gray.darkest),

  notesModalBorder: ModalColors.border,
  notedModalBG: ModalColors.background,
  notedModalMainTitle: ModalColors.title,
  noteHeaderSeparator: ModalColors.separator,
  itemSeparator: ModalColors.itemSeparator,
  bottomSeparator: ModalColors.bottomSeparator,
  closeModalIconColor: ModalColors.closeIconColor,
  viewMessageTitle: createColor(palette.gray.charcoal, palette.gray.charcoal),
  notesModalTitle: createColor(palette.blue.onTint, palette.dark.textAlt),
  noteSectionBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  noteSectionSelectedBorder: createColor(palette.blue.primary, palette.blue.primary),
  noteSectionSelectedBG: createColor(palette.opacity.blue08),
  noteSectionTitle: createColor(palette.blue.onTint, palette.dark.textAlt),
  noteSectionValue: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  noteSectionRadioBorder: createColor(palette.gray.borderAlt2, palette.gray.borderAlt2),
  noteSectionRadioSelectedBorder: createColor(palette.blue.primary, palette.blue.primary),
  noteSectionRadioSelectedBG: createColor(palette.opacity.blue08, palette.opacity.blue08),
  noteSubjectTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  noteSubjectPlaceholder: createColor(palette.gray.lightDarkGrey, palette.gray.charcoal),
  charactersText: createColor(palette.gray.placeholderText, palette.gray.charcoal),
  noteSummaryTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  noteSummaryPlaceholder: createColor(palette.gray.charcoal, palette.dark.textAlt),
  noteLog: createColor(palette.blue.onTint, palette.dark.textAlt),
  noteLogLeftVal: createColor(palette.blue.onTint, palette.dark.textAlt),
  createdKey: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  createdValue: createColor(palette.gray.darkest, palette.gray.darkest),
  cancelCTABorder: createColor(palette.gray.neutral, 'transparent'),
  changeSelectionBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  cancelCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  saveNoteCTAEnabledBG: createColor(palette.blue.primary, palette.blue.primary),
  saveNoteCTAEnabledBGText: createColor(palette.gray.white, palette.gray.white),
  saveNoteCTADisabledBG: createColor(palette.gray.neutral, palette.dark.cardSelected),
  saveNoteCTADisabledText: createColor(palette.gray.darkest, palette.dark.textAlt),
  listeningEnabledCTABG: createColor(palette.blue.primary, palette.blue.primary),
  listeningEnabledCTAText: createColor(palette.gray.white, palette.gray.white),
  listeningEnableIconColor: createColor(palette.gray.white, palette.gray.white),
  listeningEnableIconBG: createColor(palette.blue.primary, palette.blue.primary),
  listeningDisableIconColor: createColor(palette.gray.black, palette.gray.black),
  listeningDisableIconBG: createColor(palette.opacity.gray86, palette.opacity.gray86),
  mandatoryIconColor: commonColors.darkRed,
  mandatoryIconBG: createColor(palette.backgrounds.pink, palette.backgrounds.pink),
  woStatusTitle: createColor(palette.blue.onTint, palette.dark.textAlt),
  woStatusDesc: createColor(palette.blue.onTint, palette.gray.darkest),
  selectedtabBGColor: createColor(palette.blue.sky, palette.dark.cardAlt),
  selectedtabBorder: createColor(palette.borders.selected, palette.dark.techBorder),
  woStatusSubTitle: createColor(palette.gray.lightDarkGrey, palette.gray.charcoal),

  partsSearchResultTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  partsFoundBG: createColor(palette.opacity.gray80, palette.opacity.gray80),
  partsFoundBText: createColor(palette.gray.darker, palette.gray.darker),
  partsResultTitleBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  partsResultTitleColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  partsResultStatus: createColor(palette.gray.darkest, palette.gray.darkest),
  partsResultSubTitleColor: createColor(palette.blue.onTint, palette.gray.white),
  partsResultsPartName: createColor(palette.blue.onTint, palette.dark.textAlt),
  partsResultsPartDesc: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  partsResultDescColor: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  outOfStockColor: createColor(palette.semantic.outOfStockRed, palette.semantic.outOfStockRed),
  outOfStockBG: createColor(palette.backgrounds.lightRed, palette.backgrounds.lightRed),
  inStockColor: createColor(palette.semantic.darkGreen, palette.semantic.darkGreen),
  inStockBG: createColor(palette.backgrounds.successGreen, palette.backgrounds.successGreen),
  quantityDisableBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  quantityEnableBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  quantityDisableIconColor: createColor(palette.gray.darker, palette.gray.darker),
  quantityDisableTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  quantityEnableIconColor: createColor(palette.gray.darker, palette.gray.darker),
  quantityEnableTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  addDisabledBG: createColor(palette.gray.neutral, palette.gray.neutral),
  addDisabledText: createColor(palette.gray.darkest, palette.gray.darkest),
  addEnabledBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  addEnabledText: createColor(palette.gray.darkest, palette.gray.darkest),
  closeIconColor: createColor(palette.gray.darker, palette.gray.darker),
  noPartsResultBG: createColor(palette.gray.veryLight, palette.gray.veryLight),
  noPartsResultBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  noPartsResultIconBG: createColor(palette.gray.divider, palette.gray.divider),
  noPartsResultIconText: createColor(palette.gray.charcoal, palette.gray.charcoal),
  noPartsResultTitle: createColor(palette.blue.onTint, palette.gray.white),
  noPartsResultDesc: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  primaryIconColor: createColor(palette.gray.white, palette.gray.white),
  messageIconColor: createColor(palette.gray.charcoal, palette.dark.textAlt),

  confirmPartsSubTitle: createColor(palette.gray.charcoal, palette.gray.charcoal),
  header: createColor(palette.gray.darkest, palette.gray.darkest),
  partName: createColor(palette.blue.onTint, palette.dark.textAlt),
  reqQuantity: createColor(palette.gray.darkest, palette.dark.textAlt),
  partNumberKey: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  partNumberValue: createColor(palette.blue.onTint, palette.dark.textAlt),
  partNumberValueBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  partIdKey: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  partIdValue: createColor(palette.gray.field, palette.gray.field),
  partIdValueBorder: createColor(palette.gray.darkest, palette.gray.darkest),
  woDetails: createColor(palette.gray.darkest, palette.gray.darkest),
  bottomTabsKey: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  bottomTabsvalue: createColor(palette.blue.onTint, palette.dark.textAlt),
  bottomTabsBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  separatorLineParts: createColor(palette.gray.borderLight, palette.gray.borderLight),

  endShiftInfoBG: createColor(palette.backgrounds.warningYellow, palette.backgrounds.warningYellow),
  endShiftInfoBorder: createColor(palette.semantic.warningOrange, palette.semantic.warningOrange),
  endShiftInfoTitle: createColor(palette.semantic.warningDark, palette.semantic.warningDark),
  endShiftInfoSubTitle: createColor(palette.semantic.warningMedium, palette.semantic.warningMedium),
  shiftSummaryTile: createColor(palette.gray.darkest, palette.gray.darkest),
  shiftSummaryBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  shiftSummaryKey: createColor(palette.gray.charcoal, palette.gray.charcoal),
  shiftSummaryValue: createColor(palette.gray.darkest, palette.gray.darkest),

  adddQuantity: createColor(palette.gray.slateLight, palette.dark.cardSelected),
  addPartsNoteBg: createColor(palette.backgrounds.lightBlue, 'transparent'),
  viewNoteBG: createColor(palette.backgrounds.lightWhite, palette.dark.cardSelected),
  viewNoteInfoBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  addPartsNoteBorder: createColor(palette.borders.blue, palette.borders.blue),
  addPartsNoteText: createColor(palette.gray.mediumDark, palette.gray.mediumDark),
  pendingBackground: createColor(palette.backgrounds.lightYellow, palette.backgrounds.lightYellow),
  issuedBackground: createColor(palette.backgrounds.successGreen, 'transparent'),
  readyBackground: createColor(palette.backgrounds.lightBlue, 'transparent'),
  approvedBackground: createColor(palette.backgrounds.successGreen, 'transparent'),
  rejectedBackground: createColor(palette.backgrounds.lightRed, 'transparent'),
  requestedBackground: createColor(palette.backgrounds.lightBlue, 'transparent'),
  onOrderBackground: createColor(palette.backgrounds.lightOnOrder, 'transparent'),
  pendingBorder: createColor(palette.semantic.warningOrange, palette.semantic.warningOrange),
  issuedBorder: createColor(palette.semantic.issuedGreen, palette.semantic.issuedGreen),
  readyBorder: createColor(palette.semantic.readyBlue, palette.semantic.readyBlue),
  onOrderBorder: createColor(palette.semantic.onOrderPurple, palette.semantic.onOrderPurple),
  defaultStatusBackground: createColor(palette.gray.veryLight, palette.gray.veryLight),
  defaultStatusText: createColor(palette.gray.darkest, palette.gray.darkest),
  defaultStatusBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  imageColor: createColor(palette.opacity.gray50, palette.opacity.gray50),

  partMessagesBGColor: createColor(palette.gray.white, palette.dark.content),
  unReadMesageBGColor: createColor(palette.blue.unReadBlue, palette.dark.cardAlt),

  ownPartsBorder: createColor(palette.gray.divider, palette.dark.techBorder),
  additionBadgeBG: createColor(palette.gray.additionalBadge, palette.dark.cardSelected),
  charCountBG: createColor(palette.gray.charCountGrey, palette.gray.charCountGrey),
  viewInstructionsCTAColor: createColor(palette.blue.primary, palette.blue.primary),
  noViewInstructionsCTAColor: createColor(palette.dark.textLight, palette.dark.textLight),
  viewInstructionsBorderColor: createColor(palette.blue.primary, palette.blue.primary),
  meterRangeInfoBG: createColor(palette.opacity.blue08, palette.opacity.blue08),
  meterRangeInfoBorder: createColor(palette.blue.primary, palette.blue.primary),
  meterRangeInfoText: createColor(palette.blue.primary, palette.blue.primary),
  updateMeterCTAText: createColor(palette.gray.white, palette.gray.white),
  partsViewDisabledBGColor: createColor(palette.opacity.black10, palette.opacity.black10),
  meterModalTitleIconColor: createColor(palette.semantic.amberOrange, palette.semantic.amberOrange),
  accumulatedHoursExceededColor: createColor(palette.semantic.darkRed, palette.semantic.darkRed),
  accumulatedHoursNormalColor: createColor(palette.gray.darkest, palette.gray.darkest),
  notesTickMark: createColor(palette.gray.darkest, palette.gray.darkest),
  accumulatedErrorText: createColor(
    palette.opacity.highPriorityBorder,
    palette.opacity.highPriorityBorder,
  ),
  repairHistoryNoteTitle: createColor(palette.gray.lightDarkGrey, palette.gray.dark)
};
